import { useState } from "react";
import { Skeleton } from "@/components/atoms";
import { PrivateNetworkModals } from "@/components/organisms/PrivateNetwork/PrivateNetworkModals";
import { useGetNetworkParams } from "@/components/organisms/PrivateNetwork/hooks/useGetNetworkParams";
import { PrivateNetworkTable } from "@/components/organisms/PrivateNetwork/tables/PrivateNetworkTable";
import { PrivateNetworkStep } from "@/components/organisms/PrivateNetwork/types";
import { useGetNetworkQuery } from "@/redux/apis/network/networkApi";
import { useAppSelector } from "@/redux/hooks";
import { networkSelector } from "@/redux/slices/network/selectors";
import { NetworkItem } from "@/redux/slices/network/types";

export const PrivateNetworkArchived = () => {
  const { params } = useGetNetworkParams(["disconnected", "rejected"]);
  const { isLoading } = useGetNetworkQuery(params, { refetchOnMountOrArgChange: true });
  const items = useAppSelector(networkSelector);

  const [pendingDisconnectRelationship, setPendingDisconnectRelationship] = useState<NetworkItem>();
  const [pendingUpdateTier, setPendingUpdateTier] = useState<NetworkItem>();
  const [step, setStep] = useState<PrivateNetworkStep>(undefined);

  return (
    <>
      {isLoading ? (
        <Skeleton />
      ) : (
        <div className="mt-2">
          <PrivateNetworkTable
            items={items}
            setPendingDisconnectRelationship={setPendingDisconnectRelationship}
            setPendingUpdateTier={setPendingUpdateTier}
            setStep={setStep}
          />
          <PrivateNetworkTable.Pagination />
        </div>
      )}
      <PrivateNetworkModals
        step={step}
        setStep={setStep}
        setPendingDisconnectRelationship={setPendingDisconnectRelationship}
        pendingDisconnectRelationship={pendingDisconnectRelationship}
        pendingUpdateTier={pendingUpdateTier}
        setPendingUpdateTier={setPendingUpdateTier}
      />
    </>
  );
};
